import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import GetUserMedia from '../components/MediaDevices/GetUserMedia';
import WebcamView from '../components/MediaDevices/WebcamView';
import Settings from '../components/MediaDevices/Settings';
import Missing from '../components/MediaDevices/Missing';
import Doc2uToggle from './Doc2u/Toggle';
import Button from '../components/Utilities/CustomButton';

import '../styles/components/OnBoarding.scss';

const BoardingPreview = ({ className='', ...props }) => {
	const [cameraOff, setCameraOff] = useState(false);
	const [muted, setMuted] = useState(false);
	const listeners = [];
	

	// -----------------------
	// Set state on load
	// -----------------------
	useEffect(() => {
		listeners.push(window.sdk.event().on('toggleMic', (muted) => {
			setMuted(muted);
		}));

		listeners.push(window.sdk.event().on('toggleWebcam', (off) => {
			setCameraOff(off)
		}));

		// Remove listerner
		return () => {
			for (let i in listeners) {
				listeners[i]();
			}
		}
	}, []);

	
	
	// ----------------------
	// Handlers
	// ----------------------
	const toggleMic = () => {
		window.sdk.videoconf().toggleMicMute();
	};
	const toggleCam = () => {
		window.sdk.videoconf().toggleWebcamHide();
	};



	// -----------------------
	// Rendering
	// -----------------------
	return (
		<div className={`onboarding-preview`} {...props}>
			<div className={`onboarding-preview__buttons`}>
				<button className={`onboarding-preview__button ${cameraOff ? 'onboarding-preview__button--inactive' : ''} onboarding-preview__video`} onClick={toggleCam}>
					<i className={cameraOff ? 'icon-cam-off' : 'icon-cam'} />
				</button>
				<button className={`onboarding-preview__button ${muted ? 'onboarding-preview__button--inactive' : ''} onboarding-preview__audio`} onClick={toggleMic}>
					<i className={muted ? 'icon-mic-off' : 'icon-mic'} />
				</button>
			</div>
			<WebcamView noscale={true} noaudiometer={true} />
		</div>
	)
};


export default class OnBoarding extends React.Component {
	
	state = {
		needInteraction: true,
		showDeviceWorkflow: true,
		waiting: true,
		showCapteursSettings: false,
	}

	capteurs = [
		{
			name: 'Stéthoscope',
			enabled: true,
		},
		{
			name: 'Otoscope',
			enabled: false,
		},
		{
			name: 'Dermatoscope',
			enabled: true,
		},
		{
			name: 'Electrocardiogramme',
			enabled: false,
		},
		{
			name: 'Echographe Doppler',
			enabled: true,
		},
		{
			name: 'Spiromètre',
			enabled: true,
		},
	];

	sessionType;

	async componentDidMount() {
		let needInteraction = await window.sdk.videoconf().needInteraction();
		if(!needInteraction)
			await window.sdk.videoconf().init();
		this.setState({
			needInteraction: needInteraction,
			waiting: false
		});
	}
	
	onStreamReady = () => {
		this.setState({
			showDeviceSettings: true,
			showCapteursSettings: false,
		});
	}
	
	onEnter = () => {
		if(window.sdk.session().isMedecin()){
			window.sdk.toggleFullscreen();
		}
		this.props.onReady();
	}

	continue = async () => {
		await window.sdk.videoconf().init();
		this.setState({
			needInteraction: false
		});
	}

	changeDoc2uState = () => {
		this.props.changeDoc2uState();
	}

	
	// -----
	displayCapteursSettings = () => {
		this.setState({
			showCapteursSettings: true
		});
	};
	hideCapteursSettings = () => {
		this.setState({
			showCapteursSettings: false,
		});
	};

	
	render() {
		
		if (this.state.waiting)
			return 'waiting';
		
		if (this.state.needInteraction) {
			return (
				<div className="need-interaction">
					<p>Vérifiez votre connexion caméra et audio avant de démarrer votre session en cliquant sur le bouton ci-dessous</p>
					<button className='button button--primary' onClick={ this.continue }>
						Tester les dispositifs
					</button>
				</div>
			)
		}

		let isPatient = false;
		if (window.sdk.session() && window.sdk.session().session && window.sdk.session().session.name === 'patient') {
			isPatient = true;
		}

		return (
			<div className={'onboarding-config' + (isPatient ? ' test-device--patient' : '')}>
				{this.state.showDeviceWorkflow && <div className="onboarding-config__getusermedia">
					<GetUserMedia onStreamReady={ this.onStreamReady } />
				</div>}

				{this.state.showDeviceSettings && <div>
					{(isPatient && this.state.showCapteursSettings) ? (
						<>
							<div className={'onboarding-config__row'}>
								<div className={'onboarding-config__col'}>
									<div className='onboarding-config__capteurs'>
										<Missing status={this.props.doc2uState} onClick={this.changeDoc2uState} />
										{/* <Doc2uToggle status={this.props.doc2uState} onClick={this.changeDoc2uState}/> */}
									</div>
								</div>
								<div className={'onboarding-config__col'} />
							</div>
							<div className="onboarding-config__actions">
								<Button className="onboarding-config__action" variant={'primary'} onClick={this.hideCapteursSettings} outline={true}>Précédent</Button>
								<Button className="onboarding-config__action" variant={'primary'} onClick={this.hideCapteursSettings}>Valider</Button>
							</div>
							<div className="onboarding-config__actions_mobile">
								<Button className="onboarding-config__action" variant={'primary'} onClick={this.hideCapteursSettings} outline={true}>Précédent</Button>
								<Button className="onboarding-config__action" variant={'primary'} onClick={this.hideCapteursSettings}>Valider</Button>
							</div>
						</>
					) : (
						<>
							<div className="onboarding-config__preview">
								<BoardingPreview />
							</div>
							<div className="onboarding-config__devices">
								<Settings withMissing={ false } />	
							</div>
							{isPatient && (<div className="onboarding-config__devices_connected">
								<Button className="onboarding-config__action onboarding-config__toggle" variant={'primary'} outline={true} onClick={this.displayCapteursSettings}>Configuration des dispositifs connectés</Button>
							</div>)}
							<div className="onboarding-config__actions">
								<Button className="onboarding-config__action" variant={'primary'} outline={true} onClick={() => { window.sdk.event().emit('welcome') }}>Précédent</Button>
								<Button className="onboarding-config__action test-device__start" variant={'primary'} onClick={ this.onEnter }>Démarrer l'appel</Button>
							</div>
							<div className="onboarding-config__actions_mobile">
								<Button className="onboarding-config__action" variant={'primary'} outline={true} onClick={() => { window.sdk.event().emit('welcome') }}>Précédent</Button>
								<Button className="onboarding-config__action test-device__start" variant={'primary'} onClick={ this.onEnter }>Démarrer l'appel</Button>
							</div>
						</>
					)}					
				</div>}
			</div>
		);
	}
}
